import React, { useState } from "react";
import "./FAQ.css";


const faqLeft = [
  {
    id: 1,
    question: "How can I book a cab with Shreesha Tours & Travels?",
    answer:
      "You can book a cab by calling us, sending a WhatsApp message, or submitting an enquiry through our website. Our team is available 24×7 to confirm your booking.",
  },
  {
    id: 2,
    question: "Do you provide Mumbai Airport pickup and drop services?",
    answer:
      "Yes. We provide reliable airport transfers to and from Mumbai Airport and Navi Mumbai Airport with professional chauffeurs and on-time pickup service.",
  },
  {
    id: 3,
    question: "Do you offer one-way and round-trip taxi services?",
    answer:
      "Yes. We provide both one-way and round-trip cab services for local travel, airport transfers and outstation destinations across Maharashtra and India.",
  },
  {
    id: 4,
    question: "Which vehicles are available for booking?",
    answer:
      "Our fleet includes Swift Dzire, Maruti Ertiga, Toyota Rumion, Kia Carens, Innova, Innova Crysta, Tempo Traveller, Urbania and Mini Bus for every travel requirement.",
  },
];


const faqRight = [
  {
    id: 5,
    question: "Do you provide outstation cab services?",
    answer:
      "Yes. We offer comfortable outstation taxi services from Mumbai to Goa, Pune, Lonavala, Mahabaleshwar, Shirdi, Nashik, Konkan, Kolhapur and many other destinations.",
  },
  {
    id: 6,
    question: "Are your drivers experienced and verified?",
    answer:
      "Absolutely. All our chauffeurs are experienced, professionally trained, police verified and committed to providing safe and comfortable travel.",
  },
  {
    id: 7,
    question: "Do you provide Tempo Traveller and Mini Bus rental?",
    answer:
      "Yes. We offer Tempo Traveller, Urbania and Mini Bus rentals for family tours, corporate events, weddings, school trips and group travel.",
  },
  {
    id: 8,
    question: "Is your taxi service available 24×7?",
    answer:
      "Yes. Shreesha Tours & Travels operates 24 hours a day, 7 days a week, including weekends and public holidays, to serve all your travel needs.",
  },
];



function AccordionItem({item,active,setActive}){

const open = active === item.id;


return(

<div className="faq-item">


<button
className="faq-question"
onClick={()=>setActive(open ? null : item.id)}
>


<span>
{item.id}. {item.question}
</span>


<span className="faq-icon">

{open ? "−" : "+"}

</span>


</button>



{
open &&

<div className="faq-answer">

<p>
{item.answer}
</p>

</div>

}


</div>


)

}




export default function FAQ(){


const [active,setActive] = useState(null);



return(

<section className="faq-section">


<div className="container">



<div className="faq-heading">


<div className="faq-title">


<div className="title-lines">

<span></span>
<span></span>
<span></span>

</div>


<h2>
Frequently Asked Questions
</h2>


<div className="title-lines">

<span></span>
<span></span>
<span></span>

</div>


</div>



<p>

Have questions about our taxi services? Find quick answers here.
Can't find what you need? Contact us anytime.

</p>



</div>






<div className="faq-grid">



<div>

{
faqLeft.map(item=>(

<AccordionItem

key={item.id}

item={item}

active={active}

setActive={setActive}

/>

))
}

</div>





<div>

{
faqRight.map(item=>(

<AccordionItem

key={item.id}

item={item}

active={active}

setActive={setActive}

/>

))
}

</div>



</div>





<div className="faq-contact">

Still Have Questions?

<a href="/contact-us">
Contact Us
</a>

</div>



</div>


</section>


)

}